import { ProfileService } from "../adapters/ProfileService";
// Singleton instance
let profileServiceInstance = null;
const getProfileService = () => {
    if (!profileServiceInstance) {
        profileServiceInstance = new ProfileService();
    }
    return profileServiceInstance;
};
/**
 * Fetches all profile field configurations in a single request.
 * Use this as the single entry point — destructure personalInfoFields
 * and languageTimeFields from the result instead of calling the helpers separately.
 */
export const getFieldConfiguration = async () => {
    return await getProfileService().getFieldConfiguration();
};
export const getFieldConfigurations = (response) => {
    return response.personalInfoFields;
};
export const getLanguageTimeConfigurations = (response) => {
    return response.languageTimeFields;
};
